import React from "react";
import {BoxCenter, FullCenteredContainerCenter} from "app/modules/common/layout/components/containers";
import {Box, Button, Typography} from "@mui/material";

export const Maintenance = (props) => {
    return <FullCenteredContainerCenter>
        <Box sx={{ paddingTop: "20vh" }}>
            <Typography variant="h2" gutterBottom component="div" sx={{ fontWeight: "bold" }} textAlign={"center"}>
                Maintenance
            </Typography>
            <Typography variant="h6" gutterBottom component="div">
                Company is under maintenance right now. Please try later.
            </Typography>
            <BoxCenter><Button sx={{ fontSize: "24px" }} variant="text" onClick={() => window.location.href = "/"}>Re-Try</Button></BoxCenter>
        </Box>
    </FullCenteredContainerCenter>;
}
